/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_BuscarConversacion as BuscarConversacion,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ArmarOrden({
  pedidos: e,
  personas: t,
  unidades: n,
  proveedores: r,
  onClose: i,
  onCreada: a,
}) {
  let [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(e[0]?.destino ?? ``),
    [p, m] = (0, React.useState)(``),
    [h, g] = (0, React.useState)(``),
    [_, v] = (0, React.useState)(!1),
    y = n.find((e) => String(e.id) === String(o)),
    b = y && t > y.asientos,
    [x, S] = (0, React.useState)(null),
    C = e[0]?.salida,
    w = e[0]?.sede;
  (0, React.useEffect)(() => {
    if (!y?.tipo || !u) {
      S(null);
      return;
    }
    let e = !0;
    return (
      api(
        `/transporte/tarifa?origen=${encodeURIComponent(w ?? ``)}&destino=${encodeURIComponent(u)}&tipo=${encodeURIComponent(y.tipo)}`,
      )
        .then((t) => {
          e && S(t);
        })
        .catch(() => {}),
      () => {
        e = !1;
      }
    );
  }, [y?.tipo, u, w]);
  let T = (0, React.useMemo)(() => {
      if (!C || !x?.minutosViaje) return null;
      let [e, t] = C.split(`:`).map(Number),
        n = (((e * 60 + t + x.minutosViaje) % 1440) + 1440) % 1440;
      return `${String(Math.floor(n / 60)).padStart(2, `0`)}:${String(n % 60).padStart(2, `0`)}`;
    }, [C, x]),
    E = (0, React.useMemo)(
      () =>
        // Sólo las que alcanzan para el grupo (2026-10-07), de la más justa a la más grande.
        n.filter((e) => e.asientos >= t)
          .sort((a, b) => a.asientos - b.asientos || String(a.placa).localeCompare(String(b.placa)))
          .map((e) => ({
            value: String(e.id),
            label: `${e.placa} · ${e.tipo} · ${e.asientos} asientos`,
            asientos: e.asientos,
          })),
      [n, t],
    ),
    D = (0, React.useMemo)(
      () =>
        r.map((e) => ({
          value: String(e.id),
          label: e.ruc ? `${e.nombre} · ${e.ruc}` : e.nombre,
        })),
      [r],
    );
  async function O(t) {
    if ((t.preventDefault(), !_)) {
      (v(!0), g(``));
      try {
        a(
          await api(`/transporte/ordenes`, {
            method: `POST`,
            body: JSON.stringify({
              solicitudes: e.map((e) => e.id),
              unidadId: Number(o),
              proveedorId: Number(c),
              destino: u,
              observacion: p,
            }),
          }),
        );
      } catch (e) {
        g(e.message);
      } finally {
        v(!1);
      }
    }
  }
  return (
    <Modal
      titulo={`Armar orden`}
      onClose={i}
      children={
        <form
          onSubmit={O}
          aria-label={`Armar orden`}
          className={`flex flex-col gap-3`}
          children={[
            <p
              className={`text-sm text-(--text)`}
              children={[
                e.length,
                ` `,
                e.length === 1 ? `pedido` : `pedidos`,
                ` · `,
                t,
                ` personas ·`,
                ` `,
                e[0]?.salida,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Destino`,
                <input
                  value={u}
                  onChange={(e) => f(e.target.value.toUpperCase())}
                  className={Lo}
                />,
              ]}
            />,
            <label
              htmlFor={`orden-unidad`}
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Unidad`,
                <BuscarConversacion
                  id={`orden-unidad`}
                  value={o}
                  onChange={s}
                  opciones={E}
                  placeholder={`Escribí la placa, el tipo…`}
                  sugerencia={(e) => e.asientos >= t}
                />,
              ]}
            />,
            <p
              className={`-mt-2 text-xs text-(--text)`}
              children={[
                E.length ? `Sólo aparecen las unidades con ${t} asientos o más (${E.length}).` : `No hay unidades con ${t} asientos o más: separa el grupo.`,
              ]}
            />,
            <label
              htmlFor={`orden-proveedor`}
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Proveedor`,
                <BuscarConversacion
                  id={`orden-proveedor`}
                  value={c}
                  onChange={l}
                  opciones={D}
                  placeholder={`Escribí el nombre o el RUC…`}
                />,
              ]}
            />,
            <p
              className={`-mt-2 text-xs text-(--text)`}
              children={`Se elige en cada orden: la misma unidad puede venir de otro proveedor la próxima vez.`}
            />,
            b && (
              <p
                className={`text-sm text-(--warning)`}
                children={[
                  `Son `,
                  t,
                  ` personas y la unidad tiene `,
                  y.asientos,
                  ` asientos.`,
                ]}
              />
            ),
            T && (
              <p
                className={`text-sm text-(--text)`}
                children={[
                  `Sale `,
                  C,
                  ` y llega cerca de las `,
                  <strong className={`text-(--text-h)`} children={T} />,
                  ` `,
                  `(`,
                  x.minutosViaje,
                  ` min).`,
                ]}
              />
            ),
            y && u && x && !x.minutosViaje && (
              <p
                className={`text-xs text-(--text)`}
                children={`Esta ruta no tiene cargado cuánto dura. Se completa en Tarifario.`}
              />
            ),
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Observación`,
                <input
                  value={p}
                  onChange={(e) => m(e.target.value)}
                  placeholder={`Opcional`}
                  className={Lo}
                />,
              ]}
            />,
            h && <p className={`text-sm text-(--error)`} children={h} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={i}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={_ || !o || !c}
                  className={Ro}
                  children={_ ? `Armando…` : `Armar orden`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
